/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateSalesOrderItemDto = {
  /**
   * Associated sales order ID
   */
  orderId?: number;
  /**
   * Associated warehouse inventory product ID
   */
  warehouseInventoryProductId?: number;
  /**
   * Original price of the product
   */
  originalPrice?: number;
  /**
   * Markup type applied before discount
   */
  markupType?: UpdateSalesOrderItemDto.markupType;
  /**
   * Markup value
   */
  markupValue?: number;
  /**
   * Price after markup and before discount
   */
  adjustedPrice?: number;
  /**
   * Discount type
   */
  discountType?: UpdateSalesOrderItemDto.discountType;
  /**
   * Discount value
   */
  discountValue?: number;
  /**
   * Final price after markup and discount
   */
  finalPrice?: number;
};
export namespace UpdateSalesOrderItemDto {
  /**
   * Markup type applied before discount
   */
  export enum markupType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
  /**
   * Discount type
   */
  export enum discountType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
}
